// 1 > <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Get popular car list API binding >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// import React, { useState, useEffect } from "react";
// import { Box, Button, Typography, MobileStepper, Grid, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
// import { useTheme } from "@mui/system";
// // import HeartIconComponent from "./HeartIconComponent";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import DeleteIcon from "@mui/icons-material/Delete";

// export default function PopularCarSection() {
//   const theme = useTheme();
//   const [carModels, setCarModels] = useState([]);
//   const [activeStep, setActiveStep] = useState(0);
//   const [cart, setCart] = useState([]);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);

//   const cardsPerRow = 4;

//   useEffect(() => {
//     fetch("http://43.204.130.230:8084/api/master/car-model/get-all-model")
//       .then((response) => response.json())
//       .then((data) => setCarModels(data.carModelList || []))
//       .catch((error) => console.error("Error fetching car models:", error));
//   }, []);

//   const maxSteps = Math.ceil(carModels.length / cardsPerRow);
//   const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps);
//   const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
//   const currentCars = carModels.slice(activeStep * cardsPerRow, (activeStep + 1) * cardsPerRow);

//   const handleAddToCart = (car) => {
//     setCart((prevCart) => [...prevCart, car]);
//   };

//   const handleRemoveFromCart = (index) => {
//     setCart((prevCart) => prevCart.filter((_, i) => i !== index));
//   };

//   return (
//     <Box sx={{ textAlign: "center", backgroundColor: "#FDFDFD", p: 7 }}>
//       {/* HEADER WITH CART ICON */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold">
//           <span style={{ color: "#eb2329" }}>Popular</span> Cars
//         </Typography>
//         <IconButton onClick={() => setIsDrawerOpen(true)}>
//           <ShoppingCartIcon />
//           {cart.length > 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>({cart.length})</span>}
//         </IconButton>
//       </Box>

//       <MobileStepper
//         variant="dots"
//         steps={maxSteps}
//         position="static"
//         activeStep={activeStep}
//         sx={{ maxWidth: 400, mx: "auto", my: 2 }}
//         nextButton={<Button onClick={handleNext}><img src="./image/final-right-arrow-big.png" alt="Next" width={20} /></Button>}
//         backButton={<Button onClick={handleBack}><img src="./image/final-right-arrow-big.png" alt="Back" width={20} style={{ transform: "rotate(180deg)" }} /></Button>}
//       />

//       {/* DRAWER FOR CART ITEMS */}
//       <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
//         <Box sx={{ width: 300, p: 2 }}>
//           <Typography variant="h6" fontWeight="bold">Shopping Cart</Typography>
//           {cart.length === 0 ? (
//             <Typography sx={{ mt: 2 }}>Your cart is empty.</Typography>
//           ) : (
//             <List>
//               {cart.map((car, index) => (
//                 <ListItem key={index} sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <ListItemText primary={car.carModelName} secondary={`$${car.carPrice} ${car.carPriceCurrency}`} />
//                   <IconButton onClick={() => handleRemoveFromCart(index)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       </Drawer>

//       {/* CAR LIST */}
//       <Grid container spacing={2} justifyContent="center">
//         {currentCars.map((car) => (
//           <Grid item xs={12} sm={6} md={3} key={car.carModelId}>
//             <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, textAlign: "left" }}>
//               <Box sx={{ position: "relative" }}>
//                 <img src="/image/cardCarImage.png" alt="" width="100%" />
//                 <img src="./image/icon10+.svg" alt="10+" style={{ position: "absolute", top: 10, left: 10, width: 28 }} />
//                 <Button sx={{ position: "absolute", top: 10, right: 10, bgcolor: "#FF0000", color: "#fff", fontSize: 11, p: 0.5, borderRadius: 1 }}>45% OFF</Button>
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//                 <Typography fontSize={20} fontWeight="bold">{car.carModelName}</Typography>
//                 <div style={{ display: "flex" }}>
//                   <IconButton onClick={() => handleAddToCart(car)}>
//                     <ShoppingCartIcon />
//                   </IconButton>
//                   {/* <HeartIconComponent /> */}
//                 </div>
//               </Box>
//               <Typography sx={{ fontSize: 13, color: "#b7b7b7", mt: 1 }}>{car.carBrandName} - {car.carCategoriesName}</Typography>
//               <hr style={{ margin: "10px 0", border: "0.5px solid #ddd" }} />
//               <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
//                 {["Our Pics", "Premium Car", "Special Deals"].map((text, idx) => (
//                   <Button key={idx} variant="outlined" sx={{ fontSize: 10, borderRadius: 20, px: 2 }}>{text}</Button>
//                 ))}
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography sx={{ color: "#8a8a8a" }}>Total (CIF)</Typography>
//                 <Typography fontWeight="bold"> ${car.carPrice} {car.carPriceCurrency}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }

// ____________________________________________________________________________________________________________________________________________________________________________________

// 2 > <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  <<<<<<<< GET popular car list API binding And POST add to cart API binding >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, Button, Typography, MobileStepper, Grid, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
// import { useTheme } from "@mui/system";
// // import HeartIconComponent from "./HeartIconComponent";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import DeleteIcon from "@mui/icons-material/Delete";

// const API_URL = "http://43.204.144.140:8084/api/master/car-cart-and-whishlist/manage/item";

// export default function PopularCarSection() {
//   const theme = useTheme();
//   const [carModels, setCarModels] = useState([]);
//   const [activeStep, setActiveStep] = useState(0);
//   const [cart, setCart] = useState([]);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);

//   const cardsPerRow = 4;

//   useEffect(() => {
//     fetch("http://43.204.144.140:8084/api/master/car-model/get-all-model")
//       .then((response) => response.json())
//       .then((data) => setCarModels(data.carModelList || []))
//       .catch((error) => console.error("Error fetching car models:", error));
//   }, []);

//   const maxSteps = Math.ceil(carModels.length / cardsPerRow);
//   const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps);
//   const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
//   const currentCars = carModels.slice(activeStep * cardsPerRow, (activeStep + 1) * cardsPerRow);

//   const manageCartOrWishlist = async (modelId, actionType) => {
//     try {
//       const url = `http://43.204.144.140:8084/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=${encodeURIComponent(actionType)}`;

//       console.log("API Request:", url); // Debugging log

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA`,
//           "Accept-Language": "en",
//           "Content-Type": "application/json"
//         }
//       });

//       const data = await response.json();
//       console.log(`${actionType} API Response:`, data); // Debugging log

//       return data; // Ensure API response is returned
//     } catch (error) {
//       console.error(`Error in ${actionType}:`, error);
//       return null;
//     }
//   };


//   const handleAddToCart = async (car) => {
//     try {
//       console.log("Adding to cart:", car); // Debugging log

//       const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

//       if (result && result.success) {
//         setCart((prevCart) => {
//           const updatedCart = [...prevCart, car]; // Ensure we add the actual car data
//           console.log("Updated Cart:", updatedCart); // Log after the state update
//           return updatedCart;
//         });
//       } else {
//         console.error("Failed to add to cart:", result);
//       }
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     }
//   };

//   useEffect(() => {
//     console.log("Cart updated:", cart);
//   }, [cart]);



//   const handleAddToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "ADD_IN_WISHLIST");
//   };

//   const handleMoveToCart = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_CART");
//   };

//   const handleMoveToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_WISHLIST");
//   };

//   const handleRemoveFromCart = (index) => {
//     setCart((prevCart) => prevCart.filter((_, i) => i !== index));
//   };

//   return (
//     <Box sx={{ textAlign: "center", backgroundColor: "#FDFDFD", p: 7 }}>
//       {/* HEADER WITH CART ICON */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold">
//           <span style={{ color: "#eb2329" }}>Popular</span> Cars
//         </Typography>
//         <IconButton onClick={() => setIsDrawerOpen(true)}>
//           <ShoppingCartIcon />
//           {cart.length > 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>({cart.length})</span>}
//         </IconButton>
//       </Box>

//       <MobileStepper
//         variant="dots"
//         steps={maxSteps}
//         position="static"
//         activeStep={activeStep}
//         sx={{ maxWidth: 400, mx: "auto", my: 2 }}
//         nextButton={<Button onClick={handleNext}><img src="./image/final-right-arrow-big.png" alt="Next" width={20} /></Button>}
//         backButton={<Button onClick={handleBack}><img src="./image/final-right-arrow-big.png" alt="Back" width={20} style={{ transform: "rotate(180deg)" }} /></Button>}
//       />

//       {/* DRAWER FOR CART ITEMS */}
//       <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
//         <Box sx={{ width: 300, p: 2 }}>
//           <Typography variant="h6" fontWeight="bold">Shopping Cart</Typography>
//           {cart.length === 0 ? (
//             <Typography sx={{ mt: 2 }}>Your cart is empty.</Typography>
//           ) : (
//             <List>
//               {cart.map((car, index) => (
//                 <ListItem key={index} sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <ListItemText primary={car.carModelName} secondary={`$${car.carPrice} ${car.carPriceCurrency}`} />
//                   <IconButton onClick={() => handleRemoveFromCart(index)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       </Drawer>

//       {/* CAR LIST */}
//       <Grid container spacing={2} justifyContent="center">
//         {currentCars.map((car) => (
//           <Grid item xs={12} sm={6} md={3} key={car.carModelId}>
//             <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, textAlign: "left" }}>
//               <Box sx={{ position: "relative" }}>
//                 <img src="/image/cardCarImage.png" alt="" width="100%" />
//                 <img src="./image/icon10+.svg" alt="10+" style={{ position: "absolute", top: 10, left: 10, width: 28 }} />
//                 <Button sx={{ position: "absolute", top: 10, right: 10, bgcolor: "#FF0000", color: "#fff", fontSize: 11, p: 0.5, borderRadius: 1 }}>45% OFF</Button>
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//                 <Typography fontSize={20} fontWeight="bold">{car.carModelName}</Typography>
//                 <div style={{ display: "flex" }}>
//                   <Button variant="contained" onClick={() => handleAddToCart(car)}>
//                     Add To Cart
//                   </Button>
//                   {/* <IconButton onClick={() => handleAddToCart(car)}>
//                     <ShoppingCartIcon />
//                   </IconButton> */}
//                   {/* <IconButton onClick={() => handleAddToWishlist(car)}>
//                     <HeartIconComponent />
//                   </IconButton> */}
//                 </div>
//               </Box>
//               <Typography sx={{ fontSize: 13, color: "#b7b7b7", mt: 1 }}>{car.carBrandName} - {car.carCategoriesName}</Typography>
//               <hr style={{ margin: "10px 0", border: "0.5px solid #ddd" }} />
//               <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
//                 {["Our Pics", "Premium Car", "Special Deals"].map((text, idx) => (
//                   <Button key={idx} variant="outlined" sx={{ fontSize: 10, borderRadius: 20, px: 2 }}>{text}</Button>
//                 ))}
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography sx={{ color: "#8a8a8a" }}>Total (CIF)</Typography>
//                 <Typography fontWeight="bold"> ${car.carPrice} {car.carPriceCurrency}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }

// 3 > <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< GET popular car list API binding And POST add to cart API binding and GET CART LIST >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, Button, Typography, MobileStepper, Grid, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
// import { useTheme } from "@mui/system";
// import HeartIconComponent from "./HeartIconComponent";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import DeleteIcon from "@mui/icons-material/Delete";

// const API_URL = "http://13.127.195.248:8084/api/master/car-cart-and-whishlist/manage/item";
// const CART_API_URL = "http://13.127.195.248:8084/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART";
// const AUTH_TOKEN = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA";

// export default function PopularCarSection() {
//   const theme = useTheme();
//   const [carModels, setCarModels] = useState([]);
//   const [activeStep, setActiveStep] = useState(0);
//   const [cart, setCart] = useState([]);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);

//   const cardsPerRow = 4;

//   useEffect(() => {
//     fetch("http://13.127.195.248:8084/api/master/car-model/get-all-model")
//       .then((response) => response.json())
//       .then((data) => setCarModels(data.carModelList || []))
//       .catch((error) => console.error("Error fetching car models:", error));
//       fetchCartItems(); // Ensure cart items are loaded at least once on page load
//       // console.log("Cart updated:", cart);
//   }, []);

//   useEffect(() => {
//     fetchCartItems();
//   }, []);
//   //______________________________________________________
//   // useEffect(() => {
//   //   console.log("Cart updated:", cart);
//   // }, [cart]);
//   const fetchCartItems = async () => {
//     try {
//       const response = await axios.get(CART_API_URL, {
//         headers: { Authorization: AUTH_TOKEN }
//       });

//       console.log("Fetched Cart Items:", response.data.items);

//       // Ensure reactivity by updating state properly
//       setCart([...response.data.items || []]); 
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };
//   //______________________________________________________
//   // const fetchCartItems = async () => {
//   //   try {
//   //     const response = await axios.get(CART_API_URL, {
//   //       headers: {
//   //         Authorization: AUTH_TOKEN
//   //       }
//   //     });
//   //     setCart(response.data.items || []);
//   //   } catch (error) {
//   //     console.error("Error fetching cart items:", error);
//   //   }
//   // };

//   const maxSteps = Math.ceil(carModels.length / cardsPerRow);
//   const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps);
//   const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
//   const currentCars = carModels.slice(activeStep * cardsPerRow, (activeStep + 1) * cardsPerRow);

//   const handleDrawerOpen = () => {
//     fetchCartItems();
//     setIsDrawerOpen(true);
//   };

//   //   const handleAddToCart = async (car) => {
//   //   try {
//   //     console.log("Adding to cart:", car); // Debugging log

//   //     const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

//   //     if (result && result.success) {
//   //       setCart((prevCart) => {
//   //         const updatedCart = [...prevCart, car]; // Ensure we add the actual car data
//   //         console.log("Updated Cart:", updatedCart); // Log after the state update
//   //         return updatedCart;
//   //       });
//   //     } else {
//   //       console.error("Failed to add to cart:", result);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error adding to cart:", error);
//   //   }
//   // };

//   //______________________________________________________
//   // useEffect(() => {
//   //   console.log("Cart updated:", cart);
//   // }, [cart]);

//   // const handleAddToCart = async (car) => {
//   //   try {
//   //     console.log("Adding to cart:", car);

//   //     const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

//   //     if (result && result.success) {
//   //       // Update cart immediately with new item
//   //       setCart((prevCart) => {
//   //         const updatedCart = [...prevCart, car];
//   //         console.log("Updated Cart:", updatedCart); // Debugging log
//   //         return updatedCart;
//   //       });

//   //       // Fetch latest cart items from API after a short delay
//   //       setTimeout(() => fetchCartItems(), 300);
//   //     } else {
//   //       console.error("Failed to add to cart:", result);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error adding to cart:", error);
//   //   }
//   // };

//   const handleAddToCart = async (car) => {
//     if (!car) return; // Prevent adding undefined items

//     try {
//       console.log("Adding to cart:", car);

//       // **Optimistic UI Update - Ensure cart updates immediately**
//       setCart((prevCart) => {
//         if (!Array.isArray(prevCart)) return [car]; // Fix invalid state
//         return [...prevCart, car];
//       });

//       // **API Call**
//       const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

//       if (result && result.success) {
//         console.log("Successfully added to cart, fetching updated cart...");

//         // **Ensure latest data is fetched from backend**
//         setTimeout(fetchCartItems, 300);
//       } else {
//         console.error("Failed to add to cart:", result);
//       }
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     }
//   };
//   //______________________________________________________

//   const handleAddToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "ADD_IN_WISHLIST");
//   };

//   const handleMoveToCart = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_CART");
//   };

//   const handleMoveToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_WISHLIST");
//   };

//   const handleRemoveFromCart = (index) => {
//     setCart((prevCart) => prevCart.filter((_, i) => i !== index));
//   };

//     const manageCartOrWishlist = async (modelId, actionType) => {
//     try {
//       const url = `http://13.127.195.248:8084/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=${encodeURIComponent(actionType)}`;

//       console.log("API Request:", url); // Debugging log

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA`,
//           "Accept-Language": "en",
//           "Content-Type": "application/json"
//         }
//       });

//       const data = await response.json();
//       console.log(`${actionType} API Response:`, data); // Debugging log

//       return data; // Ensure API response is returned
//     } catch (error) {
//       console.error(`Error in ${actionType}:`, error);
//       return null;
//     }
//   };

//   return (
//     <Box sx={{ textAlign: "center", backgroundColor: "#FDFDFD", p: 7 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold">
//           <span style={{ color: "#eb2329" }}>Popular</span> Cars
//         </Typography>
//         {/* <IconButton onClick={handleDrawerOpen}>
//           <ShoppingCartIcon />
//           {cart.length > 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>({cart.length})</span>}
//         </IconButton> */}

// <IconButton onClick={handleDrawerOpen}>
//   <ShoppingCartIcon />
//   {cart.length > 0 && (
//     <span style={{ marginLeft: 5, fontSize: 14, fontWeight: "bold", color: "red" }}>
//       ({cart.length})
//     </span>
//   )}
// </IconButton>


//       </Box>

//        <MobileStepper
//         // variant="dots"
//         // steps={maxSteps}
//         // position="static"
//         // activeStep={activeStep}
//         // sx={{ maxWidth: 400, mx: "auto", my: 2 }}
//         variant="dots"
//         steps={maxSteps}
//         position="static"
//         activeStep={activeStep}
//         sx={{
//           maxWidth: 400,
//           flexGrow: 1,
//           marginBottom: "16px",
//           marginLeft: "70%",
//           marginTop: "-4%",
//           "@media (max-width: 768px)": {
//             marginLeft: "70%", // Apply marginLeft only on smaller screens
//           },
//           // Ensure space below the stepper
//           ".MuiMobileStepper-dots": {
//             display: "flex !important",
//             flexDirection: "row !important",
//             justifyContent: "center",
//             gap: "8px",
//           },
//           ".MuiMobileStepper-dotActive": { backgroundColor: "red !important" },
//         }}
//         nextButton={<Button onClick={handleNext}><img src="./image/final-right-arrow-big.png" alt="Next" width={20} /></Button>}
//         backButton={<Button onClick={handleBack}><img src="./image/final-right-arrow-big.png" alt="Back" width={20} style={{ transform: "rotate(180deg)" }} /></Button>}
//       />
//       <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
//         <Box sx={{ width: 300, p: 2 }}>
//           <Typography variant="h6" fontWeight="bold">Shopping Cart</Typography>
//           {cart.length === 0 ? (
//             <Typography sx={{ mt: 2 }}>Your cart is empty.</Typography>
//           ) : (
//             <List>
//               {cart.map((car, index) => (
//                 <ListItem key={index} sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <ListItemText primary={`${car.brand} - ${car.modelName}`} secondary={`$${car.price}`} />
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       </Drawer>

//       <Grid container spacing={2} justifyContent="center">
//          {currentCars.map((car) => (
//           <Grid item xs={12} sm={6} md={3} key={car.carModelId}>
//             <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, textAlign: "left" }}>
//               <Box sx={{ position: "relative" }}>
//                 <img src="/image/cardCarImage.png" alt="" width="100%" />
//                 <img src="./image/icon10+.svg" alt="10+" style={{ position: "absolute", top: 10, left: 10, width: 28 }} />
//                 <Button sx={{ position: "absolute", top: 10, right: 10, bgcolor: "#FF0000", color: "#fff", fontSize: 11, p: 0.5, borderRadius: 1 }}>45% OFF</Button>
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//                 <Typography fontSize={20} fontWeight="bold">{car.carModelName}</Typography>
//                 <div style={{ display: "flex" }}>
//                   <Button variant="contained" onClick={() => handleAddToCart(car)}>
//                     Add To Cart
//                   </Button>
//                   {/* <IconButton onClick={() => handleAddToCart(car)}>
//                     <ShoppingCartIcon />
//                   </IconButton> */}
//                   <IconButton onClick={() => handleAddToWishlist(car)}>
//                     <HeartIconComponent />
//                   </IconButton>
//                 </div>
//               </Box>
//               <Typography sx={{ fontSize: 13, color: "#b7b7b7", mt: 1 }}>{car.carBrandName} - {car.carCategoriesName}</Typography>
//               <hr style={{ margin: "10px 0", border: "0.5px solid #ddd" }} />
//               <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
//                 {["Our Pics", "Premium Car", "Special Deals"].map((text, idx) => (
//                   <Button key={idx} variant="outlined" sx={{ fontSize: 10, borderRadius: 20, px: 2 }}>{text}</Button>
//                 ))}
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography sx={{ color: "#8a8a8a" }}>Total (CIF)</Typography>
//                 <Typography fontWeight="bold"> ${car.carPrice} {car.carPriceCurrency}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }

// __________________________________________________________________________________ Used in header.js ***** ____________________________________________________________________________________________________________
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, Button, Typography, MobileStepper, Grid, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
// import { useTheme } from "@mui/system";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// // import DeleteIcon from "@mui/icons-material/Delete";

// const API_URL = "http://43.204.130.230:8084/api/master/car-cart-and-whishlist/manage/item";
// const CART_API_URL = "http://43.204.130.230:8084/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART";
// const AUTH_TOKEN = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA";

// export default function PopularCarSection() {
//   const theme = useTheme();
//   const [carModels, setCarModels] = useState([]);
//   const [activeStep, setActiveStep] = useState(0);
//   const [cart, setCart] = useState([]);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);

//   const cardsPerRow = 4;

//   useEffect(() => {
//     fetch("http://43.204.130.230:8084/api/master/car-model/get-all-model")
//       .then((response) => response.json())
//       .then((data) => setCarModels(data.carModelList || []))
//       .catch((error) => console.error("Error fetching car models:", error));
//       fetchCartItems(); // Ensure cart items are loaded at least once on page load
//       // console.log("Cart updated:", cart);
//   }, []);

//   const fetchCartItems = async () => {
//     try {
//       const response = await axios.get(CART_API_URL, {
//         headers: { Authorization: AUTH_TOKEN }
//       });

//       console.log("Fetched Cart Items:", response.data.items);

//       // Ensure reactivity by updating state properly
//       setCart([...response.data.items || []]); 
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const maxSteps = Math.ceil(carModels.length / cardsPerRow);
//   const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps);
//   const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
//   const currentCars = carModels.slice(activeStep * cardsPerRow, (activeStep + 1) * cardsPerRow);

//   const handleDrawerOpen = () => {
//     fetchCartItems();
//     setIsDrawerOpen(true);
//   };

//   const handleAddToCart = async (car) => {
//     if (!car) return; // Prevent adding undefined items

//     try {
//       console.log("Adding to cart:", car);

//       // **Optimistic UI Update - Ensure cart updates immediately**
//       setCart((prevCart) => {
//         if (!Array.isArray(prevCart)) return [car]; // Fix invalid state
//         return [...prevCart, car];
//       });

//       // **API Call**
//       const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

//       if (result && result.success) {
//         console.log("Successfully added to cart, fetching updated cart...");

//         // **Ensure latest data is fetched from backend**
//         setTimeout(fetchCartItems, 300);
//       } else {
//         console.error("Failed to add to cart:", result);
//       }
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//     }
//   };
//   //______________________________________________________

//   const handleAddToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "ADD_IN_WISHLIST");
//   };

//   const handleMoveToCart = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_CART");
//   };

//   const handleMoveToWishlist = async (car) => {
//     await manageCartOrWishlist(car.carModelId, "MOVE_TO_WISHLIST");
//   };

//   const handleRemoveFromCart = (index) => {
//     setCart((prevCart) => prevCart.filter((_, i) => i !== index));
//   };

//     const manageCartOrWishlist = async (modelId, actionType) => {
//     try {
//       const url = `http://43.204.130.230:8084/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=${encodeURIComponent(actionType)}`;

//       console.log("API Request:", url); // Debugging log

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA`,
//           "Accept-Language": "en",
//           "Content-Type": "application/json"
//         }
//       });

//       const data = await response.json();
//       console.log(`${actionType} API Response:`, data); // Debugging log

//       return data; // Ensure API response is returned
//     } catch (error) {
//       console.error(`Error in ${actionType}:`, error);
//       return null;
//     }
//   };

//   return (
//     <Box sx={{ textAlign: "center", backgroundColor: "#FDFDFD", p: 7 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold">
//           <span style={{ color: "#eb2329" }}>Popular</span> Cars
//         </Typography>
//         <IconButton onClick={handleDrawerOpen}>
//           <ShoppingCartIcon />
//           {cart.length > 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>({cart.length})</span>}
//         </IconButton>

//           {/* <IconButton onClick={handleDrawerOpen}>
//             <ShoppingCartIcon />
//             {cart.length > 0 && (
//               <span style={{ marginLeft: 5, fontSize: 14, fontWeight: "bold", color: "red" }}>
//                 ({cart.length})
//               </span>
//             )}
//           </IconButton> */}


//       </Box>

//        <MobileStepper
//         variant="dots"
//         steps={maxSteps}
//         position="static"
//         activeStep={activeStep}
//         // sx={{ maxWidth: 400, mx: "auto", my: 2 }}
//         sx={{
//           maxWidth: 400,
//           flexGrow: 1,
//           marginBottom: "16px",
//           marginLeft: "70%",
//           marginTop: "-4%",
//           "@media (max-width: 768px)": {
//             marginLeft: "70%", // Apply marginLeft only on smaller screens
//           },
//           // Ensure space below the stepper
//           ".MuiMobileStepper-dots": {
//             display: "flex !important",
//             flexDirection: "row !important",
//             justifyContent: "center",
//             gap: "8px",
//           },
//           ".MuiMobileStepper-dotActive": { backgroundColor: "red !important" },
//         }}
//         nextButton={<Button onClick={handleNext}><img src="./image/final-right-arrow-big.png" alt="Next" width={20} /></Button>}
//         backButton={<Button onClick={handleBack}><img src="./image/final-right-arrow-big.png" alt="Back" width={20} style={{ transform: "rotate(180deg)" }} /></Button>}
//       />
//       <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
//         <Box sx={{ width: 300, p: 2 }}>
//           <Typography variant="h6" fontWeight="bold">Shopping Cart</Typography>
//           {cart.length === 0 ? (
//             <Typography sx={{ mt: 2 }}>Your cart is empty.</Typography>
//           ) : (
//             <List>
//               {cart.map((car, index) => (
//                 <ListItem key={index} sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <ListItemText primary={`${car.brand} - ${car.modelName}`} secondary={`$${car.price}`} />
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </Box>
//       </Drawer>

//       {/* car List */}
//       <Grid container spacing={2} justifyContent="center">
//          {currentCars.map((car) => (
//           <Grid item xs={12} sm={6} md={3} key={car.carModelId}>
//             <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, textAlign: "left" }}>
//               <Box sx={{ position: "relative" }}>
//                 <img src="/image/cardCarImage.png" alt="" width="100%" />
//                 <img src="./image/icon10+.svg" alt="10+" style={{ position: "absolute", top: 10, left: 10, width: 28 }} />
//                 <Button sx={{ position: "absolute", top: 10, right: 10, bgcolor: "#FF0000", color: "#fff", fontSize: 11, p: 0.5, borderRadius: 1 }}>45% OFF</Button>
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//                 <Typography fontSize={20} fontWeight="bold">{car.carModelName}</Typography>
//                 <div style={{ display: "flex" }}>
//                   <Button variant="contained" onClick={() => handleAddToCart(car)}>
//                     Add To Cart
//                   </Button>
//                 </div>
//               </Box>
//               <Typography sx={{ fontSize: 13, color: "#b7b7b7", mt: 1 }}>{car.carBrandName} - {car.carCategoriesName}</Typography>
//               <hr style={{ margin: "10px 0", border: "0.5px solid #ddd" }} />
//               <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
//                 {["Our Pics", "Premium Car", "Special Deals"].map((text, idx) => (
//                   <Button key={idx} variant="outlined" sx={{ fontSize: 10, borderRadius: 20, px: 2 }}>{text}</Button>
//                 ))}
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography sx={{ color: "#8a8a8a" }}>Total (CIF)</Typography>
//                 <Typography fontWeight="bold"> ${car.carPrice} {car.carPriceCurrency}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }


import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button, Typography, MobileStepper, Grid, Drawer, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useTheme } from "@mui/system";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook

const API_URL = "https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item";
const CART_API_URL = "https://car.amar.co.jp/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART";
const AUTH_TOKEN = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA";

export default function PopularCarSection() {
  const theme = useTheme();
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [carModels, setCarModels] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [cart, setCart] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const cardsPerRow = 4;

  useEffect(() => {
    fetch("https://car.amar.co.jp/api/master/car-model/get-all-model")
      .then((response) => response.json())
      .then((data) => setCarModels(data.carModelList || []))
      .catch((error) => console.error("Error fetching car models:", error));
      fetchCartItems(); // Ensure cart items are loaded at least once on page load
      // console.log("Cart updated:", cart);
  }, []);

  const fetchCartItems = async () => {
    try {
      const response = await axios.get(CART_API_URL, {
        headers: { Authorization: AUTH_TOKEN }
      });

      console.log("Fetched Cart Items:", response.data.items);

      // Ensure reactivity by updating state properly
      setCart([...response.data.items || []]); 
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const maxSteps = Math.ceil(carModels.length / cardsPerRow);
  const handleNext = () => setActiveStep((prev) => (prev + 1) % maxSteps);
  const handleBack = () => setActiveStep((prev) => (prev - 1 + maxSteps) % maxSteps);
  const currentCars = carModels.slice(activeStep * cardsPerRow, (activeStep + 1) * cardsPerRow);

  const handleDrawerOpen = () => {
    fetchCartItems();
    setIsDrawerOpen(true);
  };

  // New function to handle car click navigation
  const handleCarClick = (modelId) => {
    navigate(`/product/${modelId}`); // Navigate to ProductPage with the modelId
  };

  const handleAddToCart = async (car, e) => {
    // Stop propagation to prevent navigation when clicking the Add to Cart button
    e.stopPropagation();
    
    if (!car) return; // Prevent adding undefined items

    try {
      console.log("Adding to cart:", car);

      // **Optimistic UI Update - Ensure cart updates immediately**
      setCart((prevCart) => {
        if (!Array.isArray(prevCart)) return [car]; // Fix invalid state
        return [...prevCart, car];
      });

      // **API Call**
      const result = await manageCartOrWishlist(car.carModelId, "ADD_IN_CART");

      if (result && result.success) {
        console.log("Successfully added to cart, fetching updated cart...");

        // **Ensure latest data is fetched from backend**
        setTimeout(fetchCartItems, 300);
      } else {
        console.error("Failed to add to cart:", result);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };
  //______________________________________________________

  const handleAddToWishlist = async (car, e) => {
    e.stopPropagation(); // Prevent navigation
    await manageCartOrWishlist(car.carModelId, "ADD_IN_WISHLIST");
  };

  const handleMoveToCart = async (car) => {
    await manageCartOrWishlist(car.carModelId, "MOVE_TO_CART");
  };

  const handleMoveToWishlist = async (car) => {
    await manageCartOrWishlist(car.carModelId, "MOVE_TO_WISHLIST");
  };

  const handleRemoveFromCart = (index) => {
    setCart((prevCart) => prevCart.filter((_, i) => i !== index));
  };

  const manageCartOrWishlist = async (modelId, actionType) => {
    try {
      const url = `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=${encodeURIComponent(actionType)}`;

      console.log("API Request:", url); // Debugging log

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA`,
          "Accept-Language": "en",
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();
      console.log(`${actionType} API Response:`, data); // Debugging log

      return data; // Ensure API response is returned
    } catch (error) {
      console.error(`Error in ${actionType}:`, error);
      return null;
    }
  };

  return (
    <Box sx={{ textAlign: "center", backgroundColor: "#FDFDFD", p: 7 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          <span style={{ color: "#eb2329" }}>Popular</span> Cars
        </Typography>
        <IconButton onClick={handleDrawerOpen}>
          <ShoppingCartIcon />
          {cart.length > 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>({cart.length})</span>}
        </IconButton>
      </Box>

      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{
          maxWidth: 400,
          flexGrow: 1,
          marginBottom: "16px",
          marginLeft: "70%",
          marginTop: "-4%",
          "@media (max-width: 768px)": {
            marginLeft: "70%", // Apply marginLeft only on smaller screens
          },
          ".MuiMobileStepper-dots": {
            display: "flex !important",
            flexDirection: "row !important",
            justifyContent: "center",
            gap: "8px",
          },
          ".MuiMobileStepper-dotActive": { backgroundColor: "red !important" },
        }}
        nextButton={<Button onClick={handleNext}><img src="./image/final-right-arrow-big.png" alt="Next" width={20} /></Button>}
        backButton={<Button onClick={handleBack}><img src="./image/final-right-arrow-big.png" alt="Back" width={20} style={{ transform: "rotate(180deg)" }} /></Button>}
      />
      <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <Typography variant="h6" fontWeight="bold">Shopping Cart</Typography>
          {cart.length === 0 ? (
            <Typography sx={{ mt: 2 }}>Your cart is empty.</Typography>
          ) : (
            <List>
              {cart.map((car, index) => (
                <ListItem key={index} sx={{ display: "flex", justifyContent: "space-between" }}>
                  <ListItemText primary={`${car.brand} - ${car.modelName}`} secondary={`$${car.price}`} />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Drawer>

      {/* car List */}
      <Grid container spacing={2} justifyContent="center">
        {currentCars.map((car) => (
          <Grid item xs={12} sm={6} md={3} key={car.carModelId}>
            <Box 
              sx={{ 
                p: 2, 
                border: "1px solid #ddd", 
                borderRadius: 2, 
                textAlign: "left",
                cursor: "pointer", // Show pointer cursor on hover
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
                }
              }}
              onClick={() => handleCarClick(car.carModelId)}
            >
              <Box sx={{ position: "relative" }}>
                <img src="/image/cardCarImage.png" alt="" width="100%" />
                <img src="./image/icon10+.svg" alt="10+" style={{ position: "absolute", top: 10, left: 10, width: 28 }} />
                <Button 
                  sx={{ position: "absolute", top: 10, right: 10, bgcolor: "#FF0000", color: "#fff", fontSize: 11, p: 0.5, borderRadius: 1 }}
                  onClick={(e) => e.stopPropagation()} // Prevent navigation when clicking the discount badge
                >
                  45% OFF
                </Button>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                <Typography fontSize={20} fontWeight="bold">{car.carModelName}</Typography>
                <div style={{ display: "flex" }}>
                  <Button 
                    variant="contained" 
                    onClick={(e) => handleAddToCart(car, e)}
                  >
                    Add To Cart
                  </Button>
                </div>
              </Box>
              <Typography sx={{ fontSize: 13, color: "#b7b7b7", mt: 1 }}>{car.carBrandName} - {car.carCategoriesName}</Typography>
              <hr style={{ margin: "10px 0", border: "0.5px solid #ddd" }} />
              <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                {["Our Pics", "Premium Car", "Special Deals"].map((text, idx) => (
                  <Button 
                    key={idx} 
                    variant="outlined" 
                    sx={{ fontSize: 10, borderRadius: 20, px: 2 }}
                    onClick={(e) => e.stopPropagation()} // Prevent navigation when clicking tag buttons
                  >
                    {text}
                  </Button>
                ))}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ color: "#8a8a8a" }}>Total (CIF)</Typography>
                <Typography fontWeight="bold"> ${car.carPrice} {car.carPriceCurrency}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
















































// ________________________________________________________________________________________________________________________________________________________________________________________________
//
//
//________________________________________________________________________ Header cart get Api binding get data in cart only header portion _____________________________________________________________________
// import React, { useState, useEffect } from "react";
// import logo from "../../logo.png";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import SearchIcon from "@mui/icons-material/Search";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
// import Grid from "@mui/material/Grid";
// import Badge from "@mui/material/Badge";
// import { Typography, Box } from "@mui/material";
// import {
//   Drawer,
//   IconButton,
//   Button,
//   AppBar,
//   List,
//   ListItem,
//   ListItemText,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";

// const Notes = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const [cartCount, setCartCount] = useState(0);

//   // Fetch cart data when the drawer opens
//   const fetchCartData = async () => {
//     try {
//       const response = await fetch(
//         "http://13.127.195.248:8084/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART",
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization:
//               "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZUBleGFtcGxlLmNvbSIsImV4cCI6MTc0MjUyODAwOCwiaWF0IjoxNzM4OTI4MDA4LCJhdXRob3JpdGllcyI6IiJ9.IztCmB4dsa9WZHMkTwWY782Aen6LAWtu8K3WiQhj813dnFo-NmlR-sGtqNsZ7vAjYG3cPJPconHpqx3g0JX7TA",
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.code === 200) {
//         setCartItems(data.items);
//         setCartCount(data.totalItems);
//       }
//     } catch (error) {
//       console.error("Error fetching cart data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchCartData();
//   }, []);


//   const toggleDrawerCart = (open) => (event) => {
//     if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
//       return;
//     }
//     setIsOpen(open);
//     if (open) {
//       fetchCartData();
//     }
//   };

//   return (
//     <div className="main-container">
//       <div className="header">
//         <Box sx={{ flexGrow: 1, px: { xs: 2, sm: 3 } }}>
//           <Grid container alignItems="center" spacing={2}>
//             {/* Logo */}
//             <Grid
//               item
//               xs={12}
//               sm={4}
//               md={2}
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: { xs: "center", sm: "flex-start" },
//                 gap: 2,
//               }}
//             >
//               <img
//                 src={logo}
//                 alt="Logo"
//                 className="logo"
//                 style={{
//                   backgroundColor: "white",
//                   width: "100%",
//                   maxWidth: "191px",
//                 }}
//               />
//             </Grid>

//             {/* Search Bar */}
//             <Grid item xs={12} sm={8} md={7}>
//               <Paper
//                 component="form"
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   width: "100%",
//                   border: "1px solid #f2f2f2",
//                   borderRadius: "10px",
//                 }}
//               >
//                 <InputBase
//                   sx={{ ml: 1, flex: 1, paddingLeft: "10px" }}
//                   placeholder="Find New And Used Car"
//                   inputProps={{ "aria-label": "search google maps" }}
//                 />
//                 <IconButton
//                   type="button"
//                   sx={{
//                     p: "13px",
//                     backgroundColor: "red",
//                     borderRadius: "1px 10px 10px 1px",
//                     "&:hover": { background: "red" },
//                   }}
//                   aria-label="search"
//                 >
//                   <SearchIcon
//                     className="search-button"
//                     style={{
//                       width: "83px",
//                       borderRadius: "0px",
//                       color: "white",
//                     }}
//                   />
//                 </IconButton>
//               </Paper>
//             </Grid>

//             {/* Icons Section */}
//             <Grid
//               item
//               xs={12}
//               md={3}
//               sx={{
//                 display: "flex",
//                 justifyContent: {
//                   xs: "space-between",
//                   md: "space-around",
//                 },
//                 gap: 2,
//                 mt: { xs: 2, md: 0 },
//               }}
//             >
//               <span className="header-icons">
//                 <Badge badgeContent={4} color="warning">
//                   <FavoriteIcon className="heart-icon" />
//                 </Badge>
//                 <span className="text-option" style={{ marginTop: "4px" }}>
//                   FAVOURITE
//                 </span>
//               </span>
//               <span className="header-icons">
//                 <Badge badgeContent={cartCount} color="error">
//                   <LocalMallOutlinedIcon className="cart-icon" />
//                 </Badge>

//                 <span
//                   className="text-option"
//                   style={{ marginTop: "4px" }}
//                   variant="text"
//                   onClick={toggleDrawerCart(true)}
//                 >
//                   Cart
//                 </span>
//                 <Drawer anchor="right" open={isOpen} onClose={toggleDrawerCart(false)}>
//                   <Box
//                     sx={{
//                       width: 300,
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       height: "100%",
//                       padding: 2,
//                     }}
//                   >
//                     {/* Header */}
//                     <Box
//                       sx={{
//                         width: "100%",
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//                         My Shopping Cart ({cartCount})
//                       </Typography>
//                       <IconButton onClick={toggleDrawerCart(false)}>
//                         <CloseIcon />
//                       </IconButton>
//                     </Box>

//                     {/* Cart Items List */}
//                     {cartItems.length > 0 ? (
//                       <List sx={{ width: "100%" }}>
//                         {cartItems.map((item) => (
//                           <ListItem key={item.modelId} divider>
//                             <ListItemText
//                               primary={`${item.brand} ${item.modelName}`}
//                               secondary={`$${item.price}`}
//                             />
//                           </ListItem>
//                         ))}
//                       </List>
//                     ) : (
//                       <Box
//                         sx={{
//                           flex: 1,
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <ShoppingBagOutlinedIcon
//                           sx={{ fontSize: 50, color: "red", marginBottom: 2 }}
//                         />
//                         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//                           Your Cart is Empty
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: "gray" }}>
//                           You have no items in your shopping cart yet.
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* Close Button */}
//                     <Button
//                       variant="contained"
//                       color="error"
//                       onClick={toggleDrawerCart(false)}
//                       sx={{ width: "100%" }}
//                     >
//                       Close
//                     </Button>
//                   </Box>
//                 </Drawer>
//               </span>
//               <span className="header-icons">
//                 <img src="/image/signin.svg" className="sign-in-icon" alt="" />
//                 <span className="text-option">SIGN IN</span>
//               </span>
//             </Grid>
//           </Grid>
//         </Box>
//       </div>
//     </div>
//   );
// };

// export default Notes;
